import React from 'react';
import * as R from 'ramda';

const Instructions = ({instructions}) => {
    const instruction = instructions[0];
    const instructionsText = instruction ? (
        <textarea disabled className="additional-notes-area">
            {instruction.instructions}
        </textarea>
    ) : null;

    return (
        <div>
            <div id="additional-notes-title" className="section-title">
                Instructions
            </div>
            {instructionsText}
        </div>
    );
};

export default Instructions;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/instructions.js